/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';

class Gif extends Component {
handleClick = () => {
  if (this.props.selectGif) {
    this.props.selectGif(this.props.id);
  }
}

render() {
  const src = `https://media4.giphy.com/media/${this.props.id}/giphy.webp`;
  return (
    <img
      src={src}
      alt=""
      className="gif"
      onClick={this.handleClick}
    />
  );
}
}

export default Gif;
